import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PartyPopper, BadgeIndianRupee, Ticket, X } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import api from "../lib/api";
import { RateCardBody } from "./RateCardSheet";

export const FIRST_LOGIN_KEY = "rl_first_login_welcome";

/* One-time popup on a customer's FIRST login (account created by admin/agent or self) — in-app alert, never WhatsApp. */
export const FirstLoginPopup = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [w, setW] = useState(null);
  const [rates, setRates] = useState(null);
  useEffect(() => {
    const raw = localStorage.getItem(FIRST_LOGIN_KEY);
    if (!raw) return;
    try { setW(JSON.parse(raw)); } catch { localStorage.removeItem(FIRST_LOGIN_KEY); return; }
    api.get("/games").then(async (r) => {
      const g = r.data.find((x) => x.mode !== "interval" && x.is_active !== false);
      if (!g) return;
      const d = await api.get(`/games/${g.id}`);
      setRates({ name: g.name, slats: d.data.slats || [], agent: !!d.data.agent_rates });
    }).catch(() => {});
  }, []);
  if (!w) return null;
  const close = () => { localStorage.removeItem(FIRST_LOGIN_KEY); setW(null); };
  const go = (to) => { close(); navigate(to); };
  const by = w.creator_name ? `${w.creator_role === "Agent" ? "Agent" : "Admin"} ${w.creator_name}` : null;
  return (
    <div className="fixed inset-0 z-[3500] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4" onClick={close} data-testid="first-login-popup">
      <div className="bg-white rounded-3xl w-full max-w-sm p-5 relative rl-fade-up max-h-[92vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <button onClick={close} className="absolute top-3 right-3 w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center" data-testid="first-login-close"><X className="w-4 h-4" /></button>
        <div className="w-14 h-14 rounded-2xl rl-gold-bg flex items-center justify-center mb-3"><PartyPopper className="w-7 h-7 text-slate-900" /></div>
        <h3 className="font-display font-black text-xl text-slate-900" data-testid="first-login-title">வணக்கம் {user?.name || ""} 🙏</h3>
        <p className="text-sm text-slate-700 mt-1">ROYAL LAKSHMI-க்கு welcome! {by ? <span data-testid="first-login-by">உங்கள் account <b>{by}</b> உருவாக்கினார்.</span> : "உங்கள் account தயார்."}{w.agent_name && w.creator_role !== "Agent" && <span> உங்கள் agent: <b>{w.agent_name}</b>.</span>}</p>
        <p className="text-xs text-slate-500 mt-2">அடுத்த முறை mobile number மட்டும் போட்டா login ஆகிடும். இன்றைய shows open — rate card பார்த்து book பண்ணுங்க.</p>
        {rates && rates.slats.length > 0 && (
          <div className="mt-3 rounded-2xl bg-slate-50 border border-slate-200 p-2.5" data-testid="first-login-rates">
            <div className="flex items-center justify-between mb-1.5">
              <div className="text-[11px] font-black text-slate-800">🔥 உங்கள் Rate & Winning</div>
              <div className="text-[10px] text-slate-500">{rates.agent ? <span className="text-emerald-700 font-bold" data-testid="first-login-rates-agent">உங்கள் agent rate</span> : rates.name}</div>
            </div>
            <div className="max-h-44 overflow-y-auto pr-0.5"><RateCardBody slats={rates.slats} rateMode="customer" /></div>
          </div>
        )}
        <div className="grid grid-cols-2 gap-2 mt-4">
          <button onClick={() => go("/rate-card")} className="rl-card py-2.5 rounded-xl text-sm font-bold flex items-center justify-center gap-1.5 text-blue-700" data-testid="first-login-rate-card"><BadgeIndianRupee className="w-4 h-4" />Rate card</button>
          <button onClick={() => go("/")} className="rl-gold-bg py-2.5 rounded-xl text-sm font-black flex items-center justify-center gap-1.5" data-testid="first-login-book"><Ticket className="w-4 h-4" />Book பண்ணுங்க</button>
        </div>
      </div>
    </div>
  );
};
